import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { sendContactUs, resetContactUs } from "../../store/slices/sendContactUsSlice.js";
import styles from "./ContacUs.module.css";
import arrowbtn from "../../assets/svg/arrowbtn.svg";

// Основной компонент формы
const ContacUsForm = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const dispatch = useDispatch();
  const { status } = useSelector(state => state.contactUs);
  const [isSuccess, setIsSuccess] = useState(false);

  const { executeRecaptcha } = useGoogleReCaptcha();

  // 5.7: Сброс при монтировании и размонтировании
  useEffect(() => {
    setIsSuccess(false);
    dispatch(resetContactUs());
    return () => {
      dispatch(resetContactUs());
    };
  }, [dispatch]);

  // Обработчик отправки формы
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!executeRecaptcha) {
      console.error("reCAPTCHA not ready yet");
      return;
    }

    try {
      const token = await executeRecaptcha("submit");

      const formData = {
        email: email,
        text: message,
        recaptcha_token: token,
      };

      dispatch(sendContactUs(formData));
    } catch (error) {
      console.error("Error generating reCAPTCHA token:", error);
    }
  };

  useEffect(() => {
    if (status === "succeeded") {
      setEmail("");
      setMessage("");
      setIsSuccess(true);
      // 5.6: Авто-скрытие через 4 секунды
      const timer = setTimeout(() => {
        setIsSuccess(false);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [status]);

  return (
    <div className={styles.block}>
      <h2 className={styles.title}>We’d love to hear from you!</h2>
      <p className={styles.text}>
        Have feedback, a question, or just want to get in touch? Let us know by filling out the form below.
      </p>
      <form onSubmit={handleSubmit} className={styles.form_container}>
        <div className={styles.form_group}>
          <input
            type="email"
            id="email"
            placeholder="E-mail"
            className={styles.form_input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className={styles.form_group}>
          <textarea
            id="message"
            placeholder="Didn't find what you needed? Have an idea or suggestion? Just want to say hi?"
            className={`${styles.form_input} ${styles.textarea_field}`}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          ></textarea>
        </div>
        <button type="submit" className={styles.submit_button}>
          <p>Submit</p>
          <img style={{ opacity: "1" }} src={arrowbtn} alt="arrow" />
        </button>
        {isSuccess && (
          <p className={styles.succes}>Thanks — we received your message.</p>
        )}
      </form>
    </div>
  );
};

// Обычный экспорт, без провайдера
const ContacUs = () => {
  return <ContacUsForm />;
};

export default ContacUs;
